export default {
  'app.org.title': '組織',
  'app.org.column.id': '組織ID',
  'app.org.column.name': '組織名',
  'app.org.column.timezone': 'タイムゾーン',
  'app.org.column.website': 'URL',
  'app.org.column.isCreator': '作成者',
  'app.org.column.createTime': '作成時間',
  'app.org.column.operate': '操作',
  'app.org.column.operate.enter': '入る',
  'app.org.column.operate.edit': '編集',
  'app.org.column.operate.delete': '削除',
  'app.org.column.operate.placeholder': '組織名/組織IDを入力してください',
  'app.org.create': '組織を作成',
  'app.org.create.submit': '組織を作成する',
  'app.org.bind.tip': '新しい組織を作成する',
  'app.org.create.tip': '既に組織をお持ちですか？',
  'app.org.create.tip.bind': 'バインドする',
  'app.org.success.tip': 'コンソールに戻る',
  'app.org.bind': '組織をバインド',
  'app.org.bind.submit': 'バインドを完了',
  'app.org.create.create': '作成する',
  'app.org.create.cancel': 'キャンセル',
  'app.org.create.save': '保存する',
  'app.org.create.profile': '組織プロフィール',
  'app.org.create.name.placeholder': '組織名を入力',
  'app.org.create.website.placeholder': 'URLを入力（トップレベルドメイン）',
  'app.org.create.timezone': 'タイムゾーン',
  'app.org.create.timezone.tip': '（一度選択すると変更できません）',
  'app.org.create.currency': '通貨',
  'app.org.create.usd': '米ドル',
  'app.org.create.success': '作成に成功しました',
  'app.org.edit.success': '編集に成功しました',
  'app.org.rule.blank': 'このフィールドは必須です',
  'app.org.rule.char': '組織名に不正な文字が含まれています',
  'app.org.rule.name.exists': '組織名は既に存在します',
  'app.org.rule.url.exists': 'URLは既に存在します',
  'app.org.rule.url.start': 'wwwで始まるURLを入力してください',
  'app.org.delete.title': '組織を削除',
  'app.org.delete.content':
    '警告！ 組織を削除すると、ユーザー、ビジネス、残高、請求書、注文、利益などのデータや情報が永久に削除され、すべての関連サービスが終了します。',
  'app.org.delete.warn': '追加支払いがある場合、アカウントを削除できません！',
  'app.org.delete.cancel': 'キャンセル',
  'app.org.delete.next': '次へ',
  'app.org.delete.delete': '削除する',
  'app.org.delete.confirm': '削除を確認',
  'app.org.delete.confirm.content':
    'アカウント削除が有効になる前に、以下のようにアカウントを確認します。認証コードはメールで送信されます。',
  'app.org.delete.confirm.send': '認証コードを送信',
  'app.org.delete.confirm.send.resend': '認証コードを再送信',
  'app.org.delete.confirm.resend': '再送信する',
  'app.org.delete.confirm.rule': '正しい認証コードを入力してください',
  'app.org.delete.success': '削除に成功しました',
  'app.org.delete.balance': 'この組織には残高があるため、削除できません。',
};
